const InnovativeSeniorWinnersList: React.FC = () => {
    return (
        <div className="text-justify py-4">
            <section className="mb-8">
                <p className="mb-2">
                    Apresiasi setinggi-tingginya kepada Para Pemenang <b>Innovative Senior</b> di <b>IIT Challenge 2024</b>! Kompetisi ini menantang pelajar SMA dan sederajat untuk merancang solusi teknologi yang aplikatif dan berdampak bagi masyarakat.
                </p>

                <p className="mb-4 font-semibold">Mengapa Kompetisi Ini Penting?</p>
                <ul className="list-disc pl-6 mb-4">
                    <li><b>Pengalaman Riset Mini:</b> Belajar meneliti dan mengembangkan solusi nyata.</li>
                    <li><b>Persiapan Dunia Profesional:</b> Membangun portofolio untuk studi dan karier.</li>
                    <li><b>Mendorong Jiwa Sosial:</b> Inovasi diarahkan untuk manfaat masyarakat.</li>
                </ul>

                <p className="mb-3 font-semibold">🎖️ Pemenang Innovative Senior IIT Challenge 2024</p>
                <ul className="list-disc pl-6 mb-4">
                    <li>
                        <p className="mb-2 font-semibold">🥇 Juara 1 – Tim Eco Warriors</p>
                        <ul className="ml-8">
                            <li className="font-semibold">• Darrekk Rayford Tjahjadi</li>
                            <li className="font-semibold">• Revand Jettha Raimun</li>
                            <p><i>(SMP Santa Angela Global Prestasi Junior High School)</i></p>
                        </ul>
                    </li>
                    <li>
                        <p className="mb-2 font-semibold">🥈 Juara 2 – Tim PGS Innovation</p>
                        <ul className="ml-8">
                            <li className="font-semibold">• Chester Adrian</li>
                            <li className="font-semibold">• Josh Lemuel Alijaya</li>
                            <p><i>(SMPK Penabur Gading Serpong)</i></p>
                        </ul>
                    </li>
                    <li>
                        <p className="mb-2 font-semibold">🥉 Juara 3 – Tim M4RC XERAPHIM</p>
                        <ul className="ml-8">
                            <li className="font-semibold">• Azulgrana Kenzia Asadel Ramadhan</li>
                            <li className="font-semibold">• Mu’thi Syamil Mumtaz</li>
                            <li className="font-semibold">• Raditya Isham Habibi</li>
                            <p><i>(MTsN 4 Jakarta Selatan)</i></p>
                        </ul>
                    </li>
                </ul>

                <p className="mb-4 font-semibold">🎁 Hadiah & Manfaat Eksklusif</p>
                <p className="mb-3">Para pemenang menerima fasilitas eksklusif untuk mendukung pengembangan skill teknologi mereka:</p>
                <ul className="list-disc pl-6 mb-4">
                    <li>✅ Software Programming Bootcamp (2 Bulan) – Senilai Rp 26.550.000</li>
                    <li>✅ Robotic Race Workshop – Persiapan untuk WIT Challenge 2024</li>
                    <li>✅ Software Programming Workshop – Persiapan untuk WIT Challenge 2024</li>
                    <li>✅ Subsidi Biaya Pendaftaran WIT Challenge 2024</li>
                </ul>
                <p className="mb-3">Hadiah ini dirancang untuk memberikan pengalaman belajar intensif dan peluang untuk berkompetisi di tingkat nasional.</p>

                <p className="mb-2 font-semibold">🚀 Bawa Inovasimu Lebih Jauh!</p>
                <p className="mb-2">Jadilah pelajar yang tidak hanya pintar, tapi juga peduli. Persiapkan ide inovatifmu untuk tahun depan!</p>

                <p className="font-semibold">
                    📸 Simak dokumentasinya di Instagram <a className="text-blue-500" href="https://www.instagram.com/iitchallenge2024/" target="_blank">@iitchallenge2024</a>
                </p>
            </section>
        </div>
    )
}
export default InnovativeSeniorWinnersList